/** Copyright 2023 Midas Healthcare Solutions - All Rights Reserved **/
import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { createFeature, createReducer, on } from '@ngrx/store';
import * as OverviewNotificationActions from './overview-notifications.actions';
import { IControlZoneNotification } from '@midas/shared/common';

export const OVERVIEW_NOTIFICATION_KEY = 'overviewnotification';

export interface OverviewNotificationState {
  notifications: EntityState<IControlZoneNotification>;
  loaded: boolean;
}

export const overviewNotificationAdapter = createEntityAdapter<IControlZoneNotification>();

const initialState: OverviewNotificationState = {
  notifications: overviewNotificationAdapter.getInitialState(),
  loaded: false,
};

export const OverviewNotificationFeature = createFeature({
  name: OVERVIEW_NOTIFICATION_KEY,
  reducer: createReducer(
    initialState,
    on(OverviewNotificationActions.queryOverviewNotificationAction, (state): OverviewNotificationState => {
      return {
        ...state,
        loaded: false,
      };
    }),
    on(
      OverviewNotificationActions.queryOverviewNotificationActionSuccess,
      (state, { carts }): OverviewNotificationState => {
        return {
          ...state,
          notifications: overviewNotificationAdapter.setAll(carts, state.notifications),
          loaded: true,
        };
      },
    ),
  ),
});
